import "./styles.css";
import { FC } from "react";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { Address } from "../../../../../shared/interfaces/address";
import { ViewContainer } from "../../../../../shared/components/viewContainer";
import SingleEntityContainer from "../../../../../shared/components/singleEntityContainer";
import { getAddressTextFields } from "../../variables/textFields";
import { CloseButton } from "../../../../../shared/components/closeButton";

interface AddressViewProps {
  id: string;
  onClose: () => void;
}
const AddressView: FC<AddressViewProps> = ({ id, onClose }) => {
  const { loading, data } = useQuery(
    `/admin/organization-addresses/${id}`,
    null
  );
  const addressData: Address = (data as any)?.data || {};
  const addressEditFields = getAddressTextFields(addressData);
  const adminEditTooltipNode =  (<>
     <CloseButton onClick={() => onClose()} />
  </>);

  return (
    <>
        <ViewContainer
          loading={loading}
        >
          <div className="entity-container">
            <SingleEntityContainer
              entityFields={addressEditFields}
              entityTitle=""
              tooltips={adminEditTooltipNode}
            ></SingleEntityContainer>
          </div>
        </ViewContainer >
    </>
  );
};
export default AddressView;
